/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import firebase from "firebase/app";
import { Link, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Accordion,
  Container,
  Grid,
  Header,
  Icon,
  Button,
  Segment,
  Message,
  List,
  Sidebar,
  Menu,
} from "semantic-ui-react";

// Components
import PdfModal from "./PdfModal";

function PdfEditor() {
  const uid = useSelector((state) => state.firebase.auth.uid);
  const [activeIndex, handleClick] = useState(0);
  const [visible, setVisible] = useState(false);
  const [pdfArray, setPdfArray] = useState([]);
  useEffect(() => {
    firebase
      .firestore()
      .collection("documentList")
      .doc(uid)
      .collection("owner")
      .get()
      .then((snap) => {
        const tempArray = pdfArray;
        snap.forEach((doc) => {
          tempArray[tempArray.length] = doc.data();
        });
        setPdfArray(tempArray);
        setVisible(true);
        setVisible(false);
      })
      .catch((err) => {
        global.alert(err);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdfArray]);

  const convertDate = (item) => {
    return new Date(item * 1).toLocaleDateString("en-US");
  };

  if (!uid) return <Redirect to="/signin" />;
  return (
    <Container style={{ height: "84vh" }}>
      <Button
        icon
        floated="right"
        labelPosition="right"
        onClick={() => setVisible(!visible)}
      >
        {!visible ? "OPEN MENU" : "CLOSE MENU"}
        <Icon name={!visible ? "right arrow" : "left arrow"} />
      </Button>
      <br />
      <br />
      <Sidebar.Pushable>
        <Sidebar
          as={Menu}
          animation="scale down"
          direction="right"
          icon="labeled"
          onHide={() => setVisible(false)}
          vertical
          visible={visible}
          width="thin"
        >
          <Menu.Item as={Link} to="/auto-fill">
            <Icon name="edit" />
            Auto Fill Panel
          </Menu.Item>
          <Menu.Item as={Link} to="/">
            <Icon name="home" />
            Home Page
          </Menu.Item>
        </Sidebar>

        <Sidebar.Pusher>
          <Grid>
            <Segment style={{ overflow: "auto", maxHeight: "80vh" }}>
              <Grid.Row>
                <Grid.Column>
                  {" "}
                  <Accordion styled>
                    {pdfArray.map((item) => {
                      return (
                        <Message color="olive" key={item.groupName}>
                          <Accordion.Title
                            active={activeIndex === 0}
                            index={0}
                            onClick={(e, { index }) =>
                              handleClick(activeIndex === index ? -1 : index)
                            }
                          >
                            <Header color="blue">
                              <Icon name="folder" />
                              {item.groupName.split("_")[1]} form group
                              <> {convertDate(item.groupName.split("_")[0])}</>
                            </Header>
                          </Accordion.Title>
                          <Accordion.Content active={activeIndex === 0}>
                            <List divided relaxed>
                              {item.documentList.map((p) => {
                                return <PdfModal item={item} value={p} />;
                              })}
                            </List>
                          </Accordion.Content>
                        </Message>
                      );
                    })}
                  </Accordion>
                </Grid.Column>
              </Grid.Row>
            </Segment>
          </Grid>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </Container>
  );
}

export default PdfEditor;

/* <List>
{pdfArray.map((item) => {
  return (
    <List.Item key={item.groupName}>
      <List.Icon size="big" name="folder" />
      <List.Content>
        <List.Header>
          {item.groupName.split("_")[1]} form group
        </List.Header>
        <List.Description>
          Source files for project
        </List.Description>
        <List.List>
          {item.documentList.map((el) => {
            return (
              <List.Item
                key={el.fileName}
                as="a"
                onClick={() => global.alert(el.fileName)}
              >
                <List.Icon
                  size="big"
                  color="red"
                  name="file pdf outline"
                />
                <List.Content>
                  <List.Header>
                    {el.fileName.split("_")[1]} pdf file
                  </List.Header>
                  <List.Description>
                    Your site's theme
                  </List.Description>
                </List.Content>
              </List.Item>
            );
          })}
        </List.List>
      </List.Content>
    </List.Item>
  );
})}
</List> */
